export default __webpack_public_path__ + "static/media/crunches.46ef519d.png";